export default __webpack_public_path__ + "static/B0067-aaa06d1ceb767936257aef04d9f846d5.png";